import React from "react";

import "./ThreeDots.styles.scss";

export const ThreeDots: React.FC = () => {
  return (
    <div className="three-dots">
      <div className="snippet" data-title="dot-flashing">
        <div className="stage">
          <div className="dot-flashing"></div>
        </div>
      </div>
    </div>
  );
};
